//@flow
import { getImage, ResourceType } from "../../util/ajax";
class SingleGetImage {
    constructor(map) {
        this.map = map;
        this.requestFunc = getImage;
    }
    get(url, cb) {
        this.destory();
        const params = this.map._transformRequest(url, ResourceType.Image);
        this.currentRequest = this.requestFunc(params, (err, image) => {
            delete this.currentRequest;
            if (err) {
                cb(err);
            } else {
                cb(err, image);
            }
        });
    }
    destory() {
        if (this.currentRequest) {
            this.currentRequest.cancel();
        }
    }
}

export default SingleGetImage;
